"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BrowserClient = void 0;

var _core = require("@sentry/core");

var _debugBuild = require("./debug-build.js");

var _eventbuilder = require("./eventbuilder.js");

var _helpers = require("./helpers.js");

var _userfeedback = require("./userfeedback.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/core Options for more information.
 */

/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */
class BrowserClient extends _core.BaseClient {
  /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */
  constructor(options) {
    const opts = _objectSpread({
      // We default this to true, as it is the safer scenario
      parentSpanIsAlwaysRootSpan: true
    }, options);

    const sdkSource = _helpers.WINDOW.SENTRY_SDK_SOURCE || (0, _core.getSDKSource)();
    (0, _core.applySdkMetadata)(opts, 'browser', ['browser'], sdkSource);
    super(opts);

    if (opts.sendClientReports && _helpers.WINDOW.document) {
      _helpers.WINDOW.document.addEventListener('visibilitychange', () => {
        if (_helpers.WINDOW.document.visibilityState === 'hidden') {
          this._flushOutcomes();
        }
      });
    }
  }
  /**
   * @inheritDoc
   */


  eventFromException(exception, hint) {
    return (0, _eventbuilder.eventFromException)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
  }
  /**
   * @inheritDoc
   */


  eventFromMessage(message, level = 'info', hint) {
    return (0, _eventbuilder.eventFromMessage)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
  }
  /**
   * Sends user feedback to Sentry.
   *
   * @deprecated Use `captureFeedback` instead.
   */


  captureUserFeedback(feedback) {
    if (!this._isEnabled()) {
      _debugBuild.DEBUG_BUILD && _core.logger.warn('SDK not enabled, will not capture user feedback.');
      return;
    }

    const envelope = (0, _userfeedback.createUserFeedbackEnvelope)(feedback, {
      metadata: this.getSdkMetadata(),
      dsn: this.getDsn(),
      tunnel: this.getOptions().tunnel
    }); // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises

    this.sendEnvelope(envelope);
  }
  /**
   * @inheritDoc
   */


  _prepareEvent(event, hint, scope) {
    event.platform = event.platform || 'javascript';
    return super._prepareEvent(event, hint, scope);
  }

}

exports.BrowserClient = BrowserClient;